<div class="card-message" [class.card-message-bg-color]="!(compact || back)" [class.card-muted]="muted" [class.card-compact]="compact">
    <div class="card-message-text" [class.card-message-textonly]="textOnly"><ng-content></ng-content></div>
    @if (!textOnly) {
        @if (back) {
            <div class="card-message-image card-message-back"></div>
        } @else {
            <div class="card-message-image card-message-symbols"></div>
        }
    }
</div>
